"use client"

import ProductsSlider from "./ProductsSlider"

const RelatedProductsSection = ({
  data,
  productsData,
  locale,
}: {
  data: any
  productsData: any
  locale: string
}) => {
  return <ProductsSlider data={data} productsdata={productsData} locale={locale} />
}

export default RelatedProductsSection
